export const TypeAction = {
  STATUS_LOAD: 'STATUS_LOAD',
  PLUS_PROD: 'PLUS_PROD',
  REMOVE_CART: 'REMOVE_CART',
  TODOS_LOADED: 'TODOS_LOADED',
  ADD_CART: 'ADD_CART',
  UPDATE_QTY: 'UPDATE_QTY',
  LOAD_ITEM: 'LOAD_ITEM',
  UPDATE_QTY_ORDER: 'UPDATE_QTY_ORDER',
  POP_UP_MODALBOX: 'POP_UP_MODALBOX',
  CHECKED_CART: 'CHECKED_CART',
}
